// extracted by mini-css-extract-plugin
export default {"Notif":"style_Notif__e91ZL","appearance":"style_appearance__LpPei"};